import React from "react";
import { useLanguage } from "../context/LanguageContext";

const DEFAULT_LOGO = "/logo_sd.png";

/**
 * Brand logo from contactInfo.logoUrl (override in admin) or bundled default.
 * @param {{ variant?: "header" | "footer" }} props
 */
export default function SiteLogo({ variant = "header" }) {
  const { contactInfo } = useLanguage();
  const raw = contactInfo?.logoUrl;
  const src = typeof raw === "string" && raw.trim() ? raw.trim() : DEFAULT_LOGO;

  const className =
    variant === "footer"
      ? "h-9 w-auto max-w-[min(88vw,260px)] md:h-11 object-contain object-left"
      : "h-7 w-auto max-w-[min(46vw,168px)] sm:h-8 sm:max-w-[220px] object-contain object-left";

  return (
    <img
      src={src}
      alt="Social Destiny"
      className={className}
      decoding="async"
      loading={variant === "header" ? "eager" : "lazy"}
      onError={(e) => {
        if (e.currentTarget.getAttribute("src")?.includes(DEFAULT_LOGO)) return;
        e.currentTarget.src = DEFAULT_LOGO;
      }}
      data-testid={variant === "header" ? "site-logo-header" : "site-logo-footer"}
    />
  );
}
